<template>
  <div id="dapin" class="hm_bc">
    <div class="hm_header">
      <div class="left-name">{{homeconfig.screen_general_title}}</div>
      <div class="center-btn">
        <div class="every-btn" :class="btnNum == 1 ? 'btn-click' : ''" @click="gopath(1)">
          {{homeconfig.screen_page_one_title}}
        </div>
        <div class="every-btn" :class="btnNum == 2 ? 'btn-click' : ''" @click="gopath(2)">
          {{homeconfig.screen_page_two_title}}
        </div>
        <div class="every-btn" :class="btnNum == 3 ? 'btn-click' : ''" @click="gopath(3)">
          {{homeconfig.screen_page_three_title}}
        </div>
        <!-- <div v-if="homeconfig.screen_page_three_title" class="every-btn" :class="btnNum == 5 ? 'btn-click' : ''" @click="gopath(5)">
          互联共建
        </div> -->
      </div>
      <div class="right-text" @click="gopath(4)">{{homeconfig.screen_general_right_title}}</div>
    </div>
    <div style="flex: 1; height: 100%; width: 100%">
      <router-view />
    </div>
  </div>
</template>
<script>
  import { pageResize } from "@/assets/js/resetScreenSize";
  import { gethomepageapi } from "@/network/api/platformghome";
  export default {
    components: {},
    data() {
      return {
        btnNum: 1,
        homeconfig:{}
      };
    },
    watch: {
      $route(to, from) {
        // console.log(to.meta.setIndex);
        this.btnNum = to.meta.setIndex
      }
    },
    mounted() {
      pageResize();
      this.getconfiginfo();
      this.btnNum = this.$route.meta.setIndex;
    },
    methods: {
      gopath(index) {
        this.btnNum = index;
        switch (index) {
          case 1:
            this.$router.push({ name: 'Team' })
            break;
          case 2:
            this.$router.push({ name: 'BasicInfo' })
            break;
          case 3:
            this.$router.push({ name: 'Achievement' })
            break;
          case 4:
            this.$router.push({ name: 'Home' })
            break;
          case 5:
            this.$router.push({ name: 'Interconnection' })
            break;
        }
      },
      async getconfiginfo() {
        let datas = await gethomepageapi();
        if (datas.data.res) {
          this.homeconfig = datas.data.res
        }
      }
    },
  };
</script>
<style lang="less" scoped>
  .hm_bc {
    width: 100%;
    height: 100%;
    background-image: url("~@/assets/images/ktscreen/bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
  }

  .hm_header {
    width: 100%;
    min-height: 0.593rem;
    max-height: 0.593rem;
    color: #fff;
    box-sizing: border-box;
    border-bottom: 0.03125rem solid #1a909e;
    position: relative;

    .left-name {
      font-size: 0.312rem;
      color: #fff;
      font-weight: bold;
      position: absolute;
      top: 0.07rem;
      left: 0.4rem;
    }

    .center-btn {
      height: 0.46rem;
      position: absolute;
      bottom: 0rem;
      left: 5.4rem;
      display: flex;
      align-items: center;

      .every-btn {
        width: 2.2rem;
        height: 100%;
        background-color: transparent;
        font-size: 0.24rem;
        font-weight: 400;
        color: #1a909e;
        /* text-align: center; */
        cursor: pointer;
        /* line-height: 0.35rem; */
        letter-spacing: 0.05rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .btn-click {
        background-color: #1a909e;
        color: #ffffff;
      }
    }

    .right-text {
      font-size: 0.3rem;
      color: #1a909e;
      position: absolute;
      right: 1.125rem;
      top: 0.07rem;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Works/platformHome/components/screenbox.vue